<template>
  <div class="home_group">
    <banner></banner>
    <div class="json">
      <div class="titles">四川升和药业股份有限公司</div>
      <div class="info_tu">
        缘起于成都制药六厂，是一家集药品研究、开发、生产、销售、医药投资为一体的高新技术企业。
      </div>
      <img class="title_icon" src="../assets/home/title_icon.png" />
    </div>
    <div class="company_profile" v-if="homeDate.company">
      <div class="bg_info_tu" :style="{ background: 'url(' + homeDate.company.company_home_one + ')' }">
        <div class="Mantle" :class="{ animation_right: showNowBtn }">
          <div class="profile">
            <div class="zh">公司简介</div>
            <div class="en">COMPANY PROFILE</div>
            <div class="line"></div>
            <div class="descyt">
              四川升和药业股份有限公司缘起于成都制药六厂，是一家集药品研究、开发、生产、销售、医药投资为一体的高新技术企业。公司兴建于邛崃的生产基地总投资约6亿元，占地面积37.2万平米，为目前西南地区技术先进的多剂型制药工厂。该基地现拥有包括片剂、硬胶囊剂、颗粒剂、滴眼剂、合剂、糖浆剂、注射剂等11条GMP认证标准生产线。
            </div>
          </div>
        </div>
      </div>
      <div class="bg_info_tu bg_info_bottom" :style="{ background: 'url(' + homeDate.company.company_home_two + ')' }">
        <div class="Mantle" :class="{ animations_left: showNowBtn }">
          <div class="profile">
            <div class="descyt">
              <p>
                公司主要产品包括颗粒制剂、滴眼剂系列、痛风等专科系列、注射剂系列以及基本药物系列，目前品种总数达124个，批准文号总数达200个，拥有独家品种9个、国家发明专利27项、国家基本药物57个、国家医疗保险药物138个。
              </p>
              <p>
                升和药业拥有一个对生命和健康充满责任感的团队，升和药业人秉承“生命每时每刻，我们用心呵护”的初心，勇于担当，以国民健康为己任，奋斗不息，崇尚学习、善于创新、精诚合作、真诚服务、提倡共赢，确保以最快的时间、最优的服务、最大限度地满足客户的需求，将企业繁荣与百姓健康紧密联系，以口碑为基石，立志做好人，做好药，做百年品牌，做高成长型的“百年企业”。
              </p>
            </div>
            <div class="btn_pom" @click="$router.push('/about')">
              <div class="left">点击查看更多</div>
              <div class="right">
                <img src="../assets/home/jiantous.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Mantle_wap">
        <div class="Mantle_wap_box_info">
          <div class="title_ou">公司简介</div>
          <div class="num_oup">COMPANY PROFILE</div>
          <div class="line"></div>
          <div class="infos">
            四川升和药业股份有限公司缘起于成都制药六厂，是一家集药品研究、开发、生产、销售、医药投资为一体的高新技术企业。公司兴建于邛崃的生产基地总投资约6亿元，占地面积37.2万平米，为目前西南地区技术先进的多剂型制药工厂。该基地现拥有包括片剂、硬胶囊剂、颗粒剂、滴眼剂、合剂、糖浆剂、注射剂等11条GMP认证标准生产线。<br />
            公司主要产品包括颗粒制剂、滴眼剂系列、痛风等专科系列、注射剂系列以及基本药物系列，目前品种总数达124个，批准文号总数达200个，拥有独家品种9个、国家发明专利27项、国家基本药物57个、国家医疗保险药物138个。<br /><br />
            升和药业拥有一个对生命和健康充满责任感的团队，升和药业人秉承“生命每时每刻，我们用心呵护”的初心，勇于担当，以国民健康为己任，奋斗不息，崇尚学习、善于创新、精诚合作、真诚服务、提倡共赢，确保以最快的时间、最优的服务、最大限度地满足客户的需求，将企业繁荣与百姓健康紧密联系，以口碑为基石，立志做好人，做好药，做百年品牌，做高成长型的“百年企业”。
          </div>
          <div class="btn_pom" @click="$router.push('/about')">
            <div class="left">点击查看更多</div>
            <div class="right">
              <img src="../assets/home/jiantous.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news">
      <div class="news_box">
        <div class="titles">
          <title-nav :zhName="'新闻资讯'" :enName="'NEWS AND INFORMATION'"></title-nav>
        </div>
      </div>
      <div class="new_content">
        <div class="news_box new_list_content">
          <div class="new_tab">
            <div class="tab_item" @click="changNewType(2)" :class="{ tab_active: news_index == 2 }">
              企业动态
            </div>
            <div class="tab_item" @click="changNewType(1)" :class="{ tab_active: news_index == 1 }">
              行业资讯
            </div>
          </div>
          <div class="news_more_contents" v-if="homeDate.news && homeDate.news[news_index]">
            <div class="left" @click="newsChangDetails(homeDate.news[news_index].recommend.id)">
              <div class="top_img">
                <img v-lazy="homeDate.news[news_index].recommend.cover" />
                <div class="times">
                  <div class="txt">{{ homeDate.news[news_index].recommend.day }}</div>
                  <div class="line"></div>
                  <div class="nums">{{ homeDate.news[news_index].recommend.month }}</div>
                </div>
              </div>
              <div class="boex">
                <div class="new_title many-txt-line">
                  {{ homeDate.news[news_index].recommend.title }}
                </div>
                <div class="new_info many-txt-line">
                  {{ homeDate.news[news_index].recommend.intro }}
                </div>
                <div class="more">查看详情></div>
              </div>
            </div>
            <div class="right">
              <div class="right_new_list">
                <div class="news_list_info" @click="newsChangDetails(homeDate.news[news_index].list[0].id)">
                  <div class="new_title list_title many-txt-line">
                    {{ homeDate.news[news_index].list[0].title }}
                  </div>
                  <div class="new_info list_info many-txt-line">
                    {{ homeDate.news[news_index].list[0].intro }}
                  </div>
                  <div class="times_list">
                    {{ homeDate.news[news_index].list[0].create_time }}
                  </div>
                  <div class="shou_more">查看详情></div>
                </div>
                <div class="line_news"></div>
                <div @click="newsChangDetails(item.id)" v-if="homeDate.news[2].list && index > 0"
                  class="news_list_case many-txt-line" v-for="(item, index) in homeDate.news[news_index].list"
                  :key="index">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product">
      <div class="titles">
        <title-nav :zhName="'产品系列'" :enName="'PRODUCT LINE'"></title-nav>
      </div>
      <div class="product_content">
        <div class="Classification">
          <div class="ClassificationItem" @click="changGroup(index, item.id)" v-for="(item, index) in homeDate.group"
            :key="index">
            <div>{{ item.name }}</div>
            <div :class="{ active_class: groupIndex == index }" class="activ_line"></div>
          </div>
        </div>
        <div class="swiper_op_pc" v-if="productList.length">
          <swiper class="swiper" :options="GroupswiperOption">
            <swiper-slide v-for="(item, index) in productList" :key="index">
              <div @click="changDetails(item.id)" class="item_product">
                <div class="img_box">
                  <img v-lazy="item.image[0]" />
                </div>
                <div class="info_tyu">
                  <div class="name one-txt-line">{{ item.name }}</div>
                  <div class="intro one-txt-line">{{ item.intro }}</div>
                  <div class="mores">查看详情></div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
        <div class="swiper_op" v-if="productList.length">
          <swiper class="swiper" :options="PcGroupswiperOption">
            <swiper-slide v-for="(item, index) in productList" :key="index">
              <div @click="changDetails(item.id)" class="item_product">
                <div class="img_box">
                  <img v-lazy="item.image[0]" />
                </div>
                <div class="info_tyu">
                  <div class="name one-txt-line">{{ item.name }}</div>
                  <div class="intro one-txt-line">{{ item.intro }}</div>
                  <div class="mores">查看详情></div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>
    <div class="survey">
      <div class="titles animate__animated" :class="{ animate__backInLeft: showSurvey }">
        <title-nav :zhName="'升和概况'" :enName="'OVERVIEW OF SHENGHE'"></title-nav>
      </div>
      <div class="info_contu animate__animated animate__slow" :class="{ animate__backInRight: showSurvey }">
        <div class="bg_info">
          <div class="info_survey animate__animated animate__slower" :class="{ animate__backInLeft: showSurvey }">
            <div class="titles">
              <div class="line"></div>
              <div class="txt">升和药业</div>
              <div class="line"></div>
            </div>
            <div class="json_info_case">
              <div class="item_survey" v-for="(item, index) in surveyList" :key="index">
                <div class="tops">
                  <span class="num_c">
                    <vns :start="0" :end="item.num" :times="120" :speed="120" />
                  </span><span class="disTy">个</span>
                </div>
                <div class="infos">{{ item.types }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "@/components/banner";
import vns from "vue-number-scroll";
import { GetBanner, getProductList } from "../api/apis";
import TitleNav from "../components/titleNav";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "home",
  components: {
    TitleNav,
    banner,
    vns,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      homeDate: {},
      showNowBtn: false,
      news_index: 2,
      showSurvey: false,

      surveyList: [
        {
          num: 124,
          types: "品种",
        },

        {
          num: 9,
          types: "独家品种",
        },
        {
          num: 138,
          types: "入选国家医保目录",
        },
        {
          num: 57,
          types: "入选国家基本药物目录",
        },
        {
          num: 1,
          types: "中医药保护品种",
        },
        {
          num: 27,
          types: "发明专利",
        },
      ],

      GroupswiperOption: {
        slidesPerView: 4,
        spaceBetween: 14,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      PcGroupswiperOption: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 8,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      groupIndex: 0,
      group_id: "",
      productList: [],
    };
  },
  methods: {
    newsChangDetails(id) {
      this.$router.push({ path: "/newDetails", query: { detaisId: id } });
    },
    changDetails(id) {
      this.$router.push({ path: "/product/details", query: { detaisId: id } });
    },
    changGroup(e, id) {
      this.groupIndex = e;
      this.group_id = id;
      this.GetProductList();
    },
    changNewType(e) {
      this.news_index = e;
    },
    getBanner() {
      GetBanner().then((res) => {
        this.homeDate = res.data;
        if (res.data.group[0].id) {
          this.group_id = res.data.group[0].id;
          this.GetProductList();
        }
      });
    },
    GetProductList() {
      let datas = {
        group_id: this.group_id,
        name: "",
        page: "",
        limit: 99999,
      };
      getProductList(datas).then((res) => {
        this.productList = res.data.data;
      });
    },
    handleScroll() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (scroll > 300) {
        this.showNowBtn = true;
      }
      if (scroll > 4000) {
        this.showSurvey = true;
      }
      if (document.body.clientWidth < 1200) {
        if (scroll > 2300) {
          this.showSurvey = true;
        }
      }
    },
  },
  mounted() {
    this.getBanner();
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="less">
.home_group {
  width: 100%;

  .json {
    width: 982px;
    margin: 60px auto 54px;
    text-align: center;

    .titles {
      font-size: 35px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }

    .info_tu {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin: 30px auto 20px;
    }

    .title_icon {
      width: 23px;
      height: 36px;
    }
  }

  .company_profile {
    width: 100%;
    height: auto;

    .Mantle_wap {
      display: none;
    }

    .bg_info_tu {
      height: 400px;
      background-size: cover !important;
      overflow: hidden;
      position: relative;

      .Mantle {
        position: absolute;
        width: 1100px;
        height: 100%;
        right: 0;
        background: rgba(0, 22, 30, 0.4);
      }

      .profile {
        position: absolute;
        left: 84px;
        width: 656px;
        cursor: pointer;
        margin-top: 38px;

        .zh {
          font-size: 35px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }

        .en {
          font-size: 35px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 46px;
          color: #ffffff;
          margin: 10px auto 14px;
        }

        .line {
          width: 338px;
          height: 0px;
          border: 1px solid #ffffff;
          margin-bottom: 30px;
        }

        .descyt {
          font-size: 17px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 26px;
          color: #ffffff;
          text-indent: 2em;

          p:nth-child(1) {
            margin-bottom: 20px;
          }
        }

        .btn_pom {
          display: flex;
          align-items: center;

          .left {
            width: 322px;
            height: 50px;
            background: #0ea4db;
            border-radius: 7px 0px 0px 7px;
            font-size: 20px;
            font-family: MicrosoftYaHei;
            line-height: 50px;
            color: #ffffff;
            text-align: center;
          }

          .right {
            width: 70px;
            height: 50px;
            background: #ffffff;
            border-radius: 0px 7px 7px 0px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 13px;
              height: 24px;
            }
          }
        }
      }
    }

    .bg_info_bottom {
      .Mantle {
        left: 0px;

        .profile {
          margin-top: 36px;
          left: 360px;

          .descyt {
            height: 270px;
          }
        }
      }
    }

    .animation_right {
      animation: rightmove 3s;
      -webkit-animation: rightmove 3s;
      /*Safari and Chrome*/
    }

    .animations_left {
      animation: mymove 3s;
      -webkit-animation: mymove 3s;
      /*Safari and Chrome*/
    }
  }

  .news {
    width: 100%;
    background: rgba(161, 217, 255, 0.12);

    .news_box {
      width: 1200px;
      margin: 0 auto;
      padding-top: 0.1px;
    }

    .titles {
      margin: 100px auto 30px;
    }

    .new_content {
      width: 100%;
      padding: 40px 0 93px;
      background-image: url("../assets/home/new_bg.png");
      background-size: cover;

      .new_list_content {
        height: 100%;

        .new_tab {
          cursor: pointer;
          display: flex;
          justify-content: center;

          .tab_item {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 25px;
            color: #666666;
            padding-bottom: 27px;
            border-bottom: 2px solid rgba(255, 255, 255, 0);
          }

          .tab_item:nth-child(1) {
            margin-right: 74px;
          }

          .tab_active {
            color: #00afef;
            border-color: #00afef;
          }
        }

        .news_more_contents {
          cursor: pointer;
          margin-top: 30px;
          display: flex;
          justify-content: space-between;
          min-height: 700px;

          .left {
            min-height: 700px;
            width: 590px;

            .top_img {
              width: 100%;
              height: 438px;
              position: relative;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

              .times {
                width: 88px;
                height: 88px;
                background: rgba(14, 164, 219, 0.9);
                position: absolute;
                bottom: 23px;
                right: 22px;
                text-align: center;

                .line {
                  width: 54px;
                  height: 0px;
                  border: 1px solid #ffffff;
                  margin: 5px auto;
                }

                .nums {
                  width: 56px;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #ffffff;
                  margin: 0 auto;
                }

                .txt {
                  width: 56px;
                  font-size: 30px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #ffffff;
                  margin: 8px auto 0;
                }
              }
            }

            .boex {
              padding: 35px 22px 24px;
              background: #ffffff;
              border: 1px solid #75b4de;
              border-top: none;

              .new_title {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                line-height: 26px;
                min-height: 52px;
                -webkit-line-clamp: 2;
              }

              .new_info {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 26px;
                color: #999999;
                -webkit-line-clamp: 3;
                margin: 20px auto 39px;
                min-height: 71px;
              }

              .more {
                font-size: 15px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #60cdf5;
              }
            }
          }

          .right {
            background: #ffffff;
            width: 580px;

            .right_new_list {
              padding: 40px 17px 44px;
              background: #ffffff;

              .news_list_info {
                .list_title {
                  font-size: 20px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 26px;
                  color: #333333;
                  -webkit-line-clamp: 2;
                }

                .list_info {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 26px;
                  color: #999999;
                  margin: 20px auto;
                  -webkit-line-clamp: 3;
                }

                .times_list {
                  font-size: 15px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                }

                .shou_more {
                  font-size: 15px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #60cdf5;
                  text-align: right;
                }
              }

              .line_news {
                width: 546px;
                height: 0px;
                border: 1px dashed #256bd7;
                margin-top: 20px;
                margin-bottom: 54px;
              }

              .news_list_case {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 26px;
                color: #333333;
                -webkit-line-clamp: 1;
                transition: all 0.3s linear;
                margin-bottom: 40px;
              }

              .news_list_case:hover {
                color: #0ea4db;
                transition: all 0.3s linear;
              }

              .news_list_case:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }

  .product {
    width: 100%;
    padding-top: 0.1px;

    .titles {
      width: 1200px;
      margin: 60px auto 31px;
    }

    .product_content {
      width: 1200px;
      margin: 0 auto;
    }

    .Classification {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      flex-wrap: wrap;

      .ClassificationItem {
        margin-right: 56px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        min-height: 51px;
        min-width: 108px;
        text-align: center;
        //margin-bottom: 5px;
      }

      .activ_line {
        width: 0px;
        height: 0px;
        transition: all 0.5s linear;
        margin: 0 auto;
        border: 2px solid #ffffff;
        margin-top: 27px;
      }

      .active_class {
        width: 72px;
        transition: all 0.5s linear;
        border-color: #00afef;
      }
    }

    .swiper_op_pc {
      display: block;
      cursor: pointer;
      margin-top: 46px;
      margin-bottom: 90px;
      position: relative;

      .item_product {
        .img_box {
          width: 100%;
          height: 324px;
          display: flex;
          align-items: center;
          overflow: hidden;

          img {
            width: 100%;
            object-fit: contain;
            transition: all 0.3s linear;
          }
        }

        .info_tyu {
          padding: 15px 14px;

          .name {
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }

          .intro {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin: 11px auto 21px;
          }

          .mores {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            text-align: right;
          }
        }
      }

      .item_product:hover {
        .img_box {
          img {
            transform: scale(1.2);
            transition: all 0.3s linear;
          }
        }

        .info_tyu {
          background: #0ea4db;
          transition: all 0.3s linear;

          .name,
          .intro {
            color: #ffffff;
          }
        }
      }
    }

    .swiper_op {
      display: none;
    }
  }

  .survey {
    background: rgba(161, 217, 255, 0.12);
    background-image: url("../assets/home/new_bg.png");
    background-size: cover;
    width: 100%;
    padding-top: 0.1px;
    height: 877px;
    padding-bottom: 170px;
    position: relative;

    .titles {
      margin: 40px auto 30px;
    }

    .animate__backInLeft {
      opacity: 1;
    }

    .info_contu {
      width: 1200px;
      height: 620px;
      background-image: url("../assets/home/surveypeo.png");
      background-size: cover;
      margin: 0 auto;
      overflow: hidden;
      opacity: 0;

      .bg_info {
        width: 100%;
        height: 100%;
        background-image: url("../assets/home/survey.png");
        background-size: 100%;
        position: relative;

        .info_survey {
          width: 694px;
          position: absolute;
          left: 95px;
          top: 93px;

          .titles {
            margin: 0 auto 59px;

            .line {
              width: 122px;
              height: 0px;
              border: 2px solid #ffffff;
            }

            .txt {
              font-size: 30px;
              font-family: PingFang SC;
              font-weight: bold;
              line-height: 42px;
              color: #ffffff;
              margin: 13px 0 15px;
            }
          }

          .json_info_case {
            display: flex;
            flex-wrap: wrap;

            .item_survey {
              width: 252px;
              height: 92px;
              border-right: 1px solid #ffffff;
              margin-bottom: 60px;
              text-align: center;

              .tops {
                margin-bottom: 5px;
                display: flex;
                align-items: center;
                justify-content: center;

                .num_c {
                  font-size: 46px;
                  font-family: PingFang SC;
                  font-weight: 800;
                  line-height: 65px;
                  color: #ffffff;
                  margin-right: 19px;
                }

                .disTy {
                  font-size: 20px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #ffffff;
                }
              }

              .infos {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
              }
            }

            .item_survey:nth-child(1),
            .item_survey:nth-child(4) {
              width: 187px;
              text-align: left;

              .tops {
                justify-content: flex-start;
              }
            }
          }
        }

        .show_active_sur {
          left: 95px;
          transition: all 0.5s linear;
        }
      }
    }

    .animate__backInRight {
      opacity: 1;
    }
  }
}

@media (max-width: 1200px) {
  .home_group {
    width: 100%;

    .json {
      width: auto;
      padding: 0 22px;
      margin: 25px auto 17px;

      .titles {
        font-size: 18px;
      }

      .info_tu {
        margin: 10px auto 17px;
        font-size: 12px;
      }

      .title_icon {
        width: 11px;
        height: 18px;
      }
    }

    .company_profile {
      width: 100%;
      height: auto;
      position: relative;

      .bg_info_tu {
        height: 230px;
        background-size: cover !important;
        overflow: hidden;
        position: relative;

        .Mantle {
          display: none;
        }

        .profile {
          position: absolute;
          left: 84px;
          width: 656px;
          cursor: pointer;
          margin-top: 38px;

          .zh {
            font-size: 35px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }

          .en {
            font-size: 35px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 46px;
            color: #ffffff;
            margin: 10px auto 14px;
          }

          .line {
            width: 338px;
            height: 0px;
            border: 1px solid #ffffff;
            margin-bottom: 30px;
          }

          .descyt {
            font-size: 17px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 26px;
            color: #ffffff;

            p:nth-child(1) {
              margin-bottom: 20px;
            }
          }

          .btn_pom {
            display: flex;
            align-items: center;

            .left {
              width: 322px;
              height: 50px;
              background: #0ea4db;
              border-radius: 7px 0px 0px 7px;
              font-size: 20px;
              font-family: MicrosoftYaHei;
              line-height: 50px;
              color: #ffffff;
              text-align: center;
            }

            .right {
              width: 70px;
              height: 50px;
              background: #ffffff;
              border-radius: 0px 7px 7px 0px;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 13px;
                height: 24px;
              }
            }
          }
        }
      }

      .Mantle_wap {
        display: block;
        width: 92%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 424px;
        background: rgba(0, 22, 30, 0.4);

        .Mantle_wap_box_info {
          padding: 19px 20px 0;

          .title_ou {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }

          .num_oup {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            margin: 5px auto 7px;
          }

          .line {
            width: 169px;
            height: 0px;
            border: 1px solid #ffffff;
            margin: 0 0 17px;
          }

          .infos {
            font-size: 11px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 15px;
            color: #ffffff;
          }

          .btn_pom {
            margin-top: 10px;
            display: flex;
            align-items: center;

            .left {
              width: 161px;
              height: 25px;
              background: #0ea4db;
              border-radius: 4px 0px 0px 4px;
              font-size: 10px;
              font-family: MicrosoftYaHei;
              line-height: 25px;
              color: #ffffff;
              text-align: center;
            }

            .right {
              width: 35px;
              height: 25px;
              background: #ffffff;
              border-radius: 0px 4px 4px 0px;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 6px;
                height: 12px;
              }
            }
          }
        }
      }

      .bg_info_bottom {
        .Mantle {
          left: 0px;

          .profile {
            margin-top: 36px;

            .descyt {
              height: 270px;
            }
          }
        }
      }

      .animation_right {
        animation: rightmove 3s;
        -webkit-animation: rightmove 3s;
        /*Safari and Chrome*/
      }

      .animations_left {
        animation: mymove 3s;
        -webkit-animation: mymove 3s;
        /*Safari and Chrome*/
      }
    }

    .news {
      .news_box {
        width: auto;
        padding: 0.1px 16px 0;
      }

      .titles {
        margin: 30px auto 16px;
      }

      .new_content {
        padding: 0 0 25px;

        .new_list_content {
          height: 100%;

          .new_tab {
            .tab_item {
              font-size: 13px;
              line-height: 18px;
              padding-bottom: 22px;
              border-bottom: 1px solid rgba(255, 255, 255, 0);
            }

            .tab_item:nth-child(1) {
              margin-right: 57px;
            }

            .tab_active {
              color: #00afef;
              border-color: #00afef;
            }
          }

          .news_more_contents {
            margin-top: 15px;
            min-height: auto;
            flex-wrap: wrap;

            .left {
              min-height: auto;
              margin-bottom: 15px;
              width: 100%;

              .top_img {
                height: 257px;
                position: relative;

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }

                .times {
                  width: auto;
                  height: auto;
                  padding: 4px 10px 8px;
                  bottom: 14px;
                  right: 13px;

                  .line {
                    width: auto;
                    height: 0px;
                    border: 1px solid #ffffff;
                    margin: 4px auto;
                  }

                  .nums {
                    width: auto;
                    font-size: 8px;
                  }

                  .txt {
                    width: auto;
                    font-size: 18px;
                    margin: 4px auto 0;
                  }
                }
              }

              .boex {
                padding: 13px 18px 15px;

                .new_title {
                  font-size: 14px;
                  line-height: 19px;
                  min-height: auto;
                }

                .new_info {
                  font-size: 10px;
                  line-height: 19px;
                  color: #999999;
                  margin: 10px auto 17px;
                }

                .more {
                  font-size: 11px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #60cdf5;
                }
              }
            }

            .right {
              background: #ffffff;
              width: 100%;

              .right_new_list {
                padding: 21px 10px 27px;

                .news_list_info {
                  .list_title {
                    font-size: 14px;
                    line-height: 19px;
                  }

                  .list_info {
                    font-size: 10px;
                    line-height: 14px;
                    margin: 9px auto 13px;
                    -webkit-line-clamp: 3;
                  }

                  .times_list {
                    font-size: 10px;
                  }

                  .shou_more {
                    font-size: 11px;
                  }
                }

                .line_news {
                  width: auto;
                  margin-top: 12px;
                  margin-bottom: 29px;
                }

                .news_list_case {
                  font-size: 14px;
                  -webkit-line-clamp: 2;
                  margin-bottom: 18px;
                }

                .news_list_case:hover {
                  color: #0ea4db;
                  transition: all 0.3s linear;
                }

                .news_list_case:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }
    }

    .product {
      width: 100%;
      padding-top: 0.1px;

      .titles {
        width: auto;
        margin: 22px auto 15px;
      }

      .product_content {
        width: auto;
        margin: 0 auto;
        padding: 0 16px;
      }

      .Classification {
        .ClassificationItem {
          margin-right: 37px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          min-height: 35px;
          min-width: 63px;
        }

        .activ_line {
          width: 0px;
          height: 0px;
          transition: all 0.5s linear;
          margin: 0 auto;
          border: 1px solid #ffffff;
          margin-top: 17px;
        }

        .active_class {
          width: 44px;
          transition: all 0.5s linear;
          border-color: #00afef;
        }
      }

      .swiper_op_pc {
        display: none;
      }

      .swiper_op {
        display: block;
        cursor: pointer;
        margin-top: 16px;
        margin-bottom: 64px;
        position: relative;

        .item_product {
          .img_box {
            width: 100%;
            height: 188px;
            display: flex;
            align-items: center;
            overflow: hidden;

            img {
              width: 100%;
              object-fit: contain;
              transition: all 0.3s linear;
            }
          }

          .info_tyu {
            padding: 9px 10px;
            background: #0ea4db;

            .name {
              color: #ffffff;
              font-size: 13px;
            }

            .intro {
              color: #ffffff;
              font-size: 10px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              margin: 5px auto 12px;
            }

            .mores {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              text-align: right;
            }
          }
        }

        .item_product:hover {
          .img_box {
            img {
              transform: scale(1.2);
              transition: all 0.3s linear;
            }
          }

          .info_tyu {
            background: #0ea4db;
            transition: all 0.3s linear;

            .name,
            .intro {
              color: #ffffff;
            }
          }
        }
      }
    }

    .survey {
      background: rgba(161, 217, 255, 0.12);
      background-image: url("../assets/home/new_bg.png");
      background-size: cover;
      width: 100%;
      height: auto;
      padding-top: 0.1px;
      padding-bottom: 78px;

      .titles {
        margin: 25px auto 20px;
        opacity: 0;
      }

      .info_contu {
        width: 100%;
        height: 310px;

        .bg_info {
          width: 100%;
          height: 100%;
          background-image: url("../assets/home/survey.png");
          background-size: 100%;
          position: relative;

          .info_survey {
            //width: 342px;
            width: auto;
            max-width: 382px;
            position: absolute;
            left: 10px;
            top: 26px;
            transition: all 0.5s linear;

            .titles {
              opacity: 1;
              margin: 0 auto 47px;

              .line {
                width: 61px;
                border: 1px solid #ffffff;
              }

              .txt {
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: bold;
                line-height: 21px;
                color: #ffffff;
                margin: 7px 0 8px;
              }
            }

            .json_info_case {
              display: flex;
              flex-wrap: wrap;

              .item_survey {
                width: 103px;
                height: 50px;
                border-right: 1px solid #ffffff;
                margin-bottom: 37px;
                text-align: center;

                .tops {
                  margin-bottom: 5px;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  .num_c {
                    font-size: 24px;
                    line-height: 35px;
                    margin-right: 11px;
                  }

                  .disTy {
                    font-size: 11px;
                  }
                }

                .infos {
                  font-size: 9px;
                }
              }

              .item_survey:nth-child(1),
              .item_survey:nth-child(4) {
                width: 125px;
                text-align: left;

                .tops {
                  justify-content: flex-start;
                }
              }

              .item_survey:nth-child(3),
              .item_survey:nth-child(6) {
                border-right: none;
              }

              .item_survey:nth-child(2),
              .item_survey:nth-child(5) {
                width: 110px;
              }
            }
          }

          .show_active_sur {
            left: 15px;
            transition: all 0.5s linear;
          }
        }
      }
    }
  }
}

@media (max-width: 420px) {}

@keyframes mymove {
  0% {
    left: -1200px;
  }

  100% {
    left: 0px;
  }
}

@-webkit-keyframes mymove

/*Safari and Chrome*/
  {
  0% {
    left: -1200px;
  }

  100% {
    left: 0px;
  }
}

@keyframes rightmove {
  0% {
    right: -1200px;
  }

  100% {
    right: 0px;
  }
}

@-webkit-keyframes rightmove

/*Safari and Chrome*/
  {
  0% {
    right: -1200px;
  }

  100% {
    right: 0px;
  }
}
</style>
<style lang="less">
.home_group {
  .product {
    .swiper_op_pc {

      .swiper-button-prev,
      .swiper-button-next {
        width: 42px;
        height: 44px;
        top: 180px;
        outline: none;
        border: none;
      }

      .swiper-button-prev {
        background-image: url("../assets/home/left.png");
        background-size: 100% 100%;
        left: -58px;
      }

      .swiper-button-next {
        background-image: url("../assets/home/right.png");
        background-size: 100% 100%;
        right: -58px;
      }
    }
  }
}

.home_group {
  .product {
    .swiper_op {

      .swiper-button-prev,
      .swiper-button-next {
        width: 21px;
        height: 22px;
        bottom: -37px;
        top: auto;
        outline: none;
        border: none;
      }

      .swiper-button-prev {
        background-image: url("../assets/home/left.png");
        background-size: 100% 100%;
        left: 0px;
      }

      .swiper-button-next {
        background-image: url("../assets/home/right.png");
        background-size: 100% 100%;
        right: 0px;
      }
    }
  }
}

@media (max-width: 1200px) {}
</style>
